import React from 'react'
import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Components/Profile/ProfileNavListItem/ProfileNavListItem.scss'
import btnCss from 'Components/Button/Button.scss'
import Input from 'Components/Input';
import Button from 'Components/Button';
import { SVGQuestionInCircle, SVGTrashSmall } from 'Components/SVGCollection';
import { isListOwner, getInitials, userNameToColor, userNameToTextColor, ShoppingListUserType, isEmailValid } from 'Utils/helpers/shoppingListHelpers';
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter';
import ListClient from 'Utils/api/ListClient';
import { connect, DispatchProp } from 'react-redux';
import { refreshShoppingLists } from 'Utils/redux/actions';
import { asyncDeleteDialog } from 'Utils/helpers/modalHelper';

type PropType = {
  listId: string
}

type ReduxPropsType = {
  shoppingLists: Redux.IShoppingListState,
  userId: string | null
}

type StateType = {
  newEmail: string
  list: ShoppingList.IShoppingList | null
  userEmailSelectedForRemoval: string | null
}

type OwnProps = PropType & ReduxPropsType & DispatchProp

class ListSharingModal extends React.Component<OwnProps, StateType> {
  state = {
    newEmail: '',
    list: null,
    userEmailSelectedForRemoval: null
  } as StateType

  static getDerivedStateFromProps(props: OwnProps, state: StateType) {
    const selectedList = props.shoppingLists.lists.find(list => list.listId === props.listId)
    return {
      list: selectedList || null
    }
  }

  componentDidUpdate() {
    uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, false)
  }

  handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newEmail: e.currentTarget.value
    })
  }

  renderUser = (user: ShoppingList.ShoppingListUser, options: { isOwner: boolean, index: number }) => {
    const initials = getInitials(user.name ? user.name : user.email)
    const nameOrEmail = user.name ? user.name : user.email
    const bubbleColor = userNameToColor(nameOrEmail)
    const bubbleTextColor = userNameToTextColor(nameOrEmail)
    const showIsPending = user.type === ShoppingListUserType.Shared && user.acceptedAt === null && options.isOwner
    const showCanRemove = user.type !== ShoppingListUserType.Owner && options.isOwner
    const removeSharingFn = () => { this.onRemoveSharing(user) }
    return (
      <div key={`userSharedBox_${options.index}`} className={cn(cl.sharingModalListItem)}>
        <div className={cn(cg.gridX, cg.alignMiddle)}>
          <div className={cn(cg.cell, cg.shrink, cl.ieAvatar)}>
            <div className={cn(cl.avatar)} style={{ backgroundColor: bubbleColor, color: bubbleTextColor }}>
                {initials}
            </div>
          </div>
          <div className={cn(cg.cell, cg.auto, cl.name)}>
            {user.name ? (
              <React.Fragment>
                <p><strong>{user.name}</strong></p>
                <p>{user.email}</p>
              </React.Fragment>
            ) : (
              <p><strong>{user.email}</strong></p>
            )}
          </div>
            {showIsPending && (
              <div className={cn(cg.cell, cg.shrink, cl.icon)} style={{paddingRight: '10px'}} title="Még nem fogadta el a megosztást">
                <SVGQuestionInCircle width={24} height={24} style={{color: '#00a3e0', marginRight: '5'}} />
              </div>
            )}
            {showCanRemove && (
              <div className={cn(cg.cell, cg.shrink, cl.ieBtn)} style={{paddingRight: '5px'}}>
                <Button
                  className={cn(btnCss.hollow, btnCss.small, cl.delete)}
                  disabled={false}
                  onClick={() => { this.setState({
                    userEmailSelectedForRemoval: user.email
                  })}}
                  renderIcon={{ ariaLabel: 'ariaLabel', Icon: <SVGTrashSmall width={21} height={21} title="Törlés" /> }}
                />
              </div>  
            )}
        </div>
        {showCanRemove && this.state.userEmailSelectedForRemoval && this.state.userEmailSelectedForRemoval === user.email && (
          <React.Fragment>
            <div className={cn(cg.gridX, cg.gridMarginX, cg.alignMiddle)} style={{paddingTop: '10px', margin: '5px'}}>
              <div className={cn(cg.cell, cg.small12, cg.medium6)}>
                <Button label="Mégsem" className={cn(btnCss.secondary, btnCss.hollow, btnCss.small, btnCss.expanded)} onClick={() => { this.setState({ userEmailSelectedForRemoval: null }) }}/>
              </div>
              <div className={cn(cg.cell, cg.small12, cg.medium6)}>
                <Button label="Megosztás törlése" className={cn(btnCss.secondary, btnCss.small, btnCss.expanded)} onClick={removeSharingFn}/>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }

  onShareList = async () => {
    uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, true)
    try {
      await ListClient.getInstance().shareList(this.state.list!.listId, this.state.newEmail.trim())
      this.props.dispatch(refreshShoppingLists())
      this.setState({
        newEmail: ''
      })
    } catch {
      // TODO: Handle error
    }    
  }

  onRemoveSharing = async (user: ShoppingList.ShoppingListUser) => {
    try {
      await ListClient.getInstance().removeSharing(this.state.list!.listId, user.email)
      this.props.dispatch(refreshShoppingLists())
      // TODO: Show success
    } catch {
      // TODO: Handle error
    }
  }

  canCreateNewShare = (email: string): boolean | string => {
    // Check length
    if (email.length === 0) {
      return false
    }
    if (!isEmailValid(email.trim())) {
      return 'A megadott e-mail cím érvénytelen!'
    }
    // Check own email
    const foundUser = this.state.list!.users.find(user => user.email === email.trim())
    if (foundUser && foundUser.userId === this.props.userId) {
      return 'Ez a saját e-mail címed!'
    }
    if (foundUser && foundUser.type === ShoppingListUserType.Owner) {
      return 'Ez a tulajdonos e-mail címe!'
    }
    if (typeof foundUser !== 'undefined') {
      return 'A megadott e-mail címmel már meg van osztva a lista!'
    }

    return true
  }

  render () {
    if (this.props.userId === null) { return null }
    if (this.state.list === null) { return null }
    const isOwner = isListOwner(this.props.userId!, this.state.list)
    const title = isOwner ? 'Lista megosztása' : 'Lista megosztások' 
    const canCreateShare = this.canCreateNewShare(this.state.newEmail)
    return (
      <>
        <div className={cn(cl.sharingModalContent)}>
          <div className={cn(cl.sharingModalHeader)}>
            <h4>{title}</h4>
            <div className={cn(cl.sharingModalFilter)}>
              <Input error={(typeof canCreateShare === 'string' ? canCreateShare : null)} name="newEmail" label="Email cím" type="text" value={this.state.newEmail} hideLabel onChange={this.handleTextChange} />
            </div>
            {isOwner && (
              <div className={cn(cl.sharingModalButton, cg.textCenter)}>
                <Button className={cn(btnCss.largeWidth)} disabled={!isOwner || canCreateShare !== true} label="Megosztás" onClick={this.onShareList} />
              </div>
            )}
          </div>  
          <div className={cn(cl.sharingModalList)}>
            {this.state.list!.users.map((user, index) => this.renderUser(user, { isOwner, index }))}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state: Redux.IReduxState) => {
  const userId = state.session.loggedIn ? state.session.customerData.id : null
  return {
    userId,
    shoppingLists: state.shoppingLists
  }
}

export default connect(mapStateToProps)(ListSharingModal)